import { Helpers } from '@bode-canada/core';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
  StyleOverflowType,
  StyleOrientationType,
  StyleFontWeightType,
  StyleBemType,
  StyleAlignmentType,
} from '../../styles/enums';
import StyleClassNamesBuilder from '../../styles/helpers/StyleClassNamesBuilder';

const StylesMixin = {
  data() {
    return {
      StyleClassNamesBuilder,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      StyleOverflowType,
      StyleOrientationType,
      StyleFontWeightType,
      StyleBemType,
      StyleAlignmentType,
    };
  },
  computed: {
    rootClassName() {
      return Helpers.StringHelper.toKebabCase(this.$options.name);
    },
  },
};

export default StylesMixin;
